import PropTypes from 'prop-types'
import React, { useRef, useEffect, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import SectionAncestry from 'components/_special/SectionAncestry'
import FaqBlock from 'components/FaqBlock'
import { GOODS_TYPES } from 'constants/sales'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import { LayoutContext } from 'contexts/Layout'
import { ResizeContext } from 'contexts/Resize'

import WResultsClinicalGenetics from './components/WResultsClinicalGenetics'
import WResultsFirst from './components/WResultsFirst'
import WResultsHealth from './components/WResultsHealth'
import WResultsInvestment from './components/WResultsInvestment'
import WResultsNutrition from './components/WResultsNutrition'
import WResultsSports from './components/WResultsSports'
import WResultsTraits from './components/WResultsTraits'
import { SectionsWrapperStyled, FaqBlockWrapper } from './styles'

const WgsResults = ({ texts, locale, pathCdn }) => {
  const secondBlock = useRef(null)
  const { mobile } = useContext(ResizeContext)
  const { setBodyColor, setFooterBg, setFooterColor } = useContext(
    LayoutContext,
  )
  const { colors } = useContext(ThemeContext)

  useEffect(() => {
    setFooterBg(colors.purpleHeart)
    setFooterColor(colors.whiteOp5)
    setBodyColor(colors.black)

    return () => {
      setFooterBg(null)
      setFooterColor(null)
      setBodyColor(null)
    }
  }, [setFooterBg, setBodyColor, colors, setFooterColor])

  return (
    <>
      <WResultsFirst data={texts.first} secondBlockRef={secondBlock} />

      <div ref={secondBlock} className="text-white">
        <WResultsHealth data={texts.health} pathCdn={pathCdn} />
      </div>
      <div className="pt-6 text-white">
        <WResultsClinicalGenetics
          data={texts.clinical_genetics}
          pathCdn={pathCdn}
        />
      </div>
      <div className="pt-6 text-white">
        <WResultsNutrition data={texts.nutrition} pathCdn={pathCdn} />
      </div>
      <div className="pt-6 text-white">
        <WResultsSports data={texts.sports} pathCdn={pathCdn} />
      </div>
      <div className="pt-6 text-white">
        <WResultsInvestment data={texts.investment} pathCdn={pathCdn} />
      </div>
      <div className="pt-6">
        <SectionAncestry
          title={texts.ancestry.title}
          list={texts.ancestry.list}
        />
      </div>
      <div className="pt-6 text-white">
        <WResultsTraits data={texts.traits} pathCdn={pathCdn} />
      </div>

      <FaqBlockWrapper>
        <FaqBlock
          wrapperClassName="py-2 py-md-4"
          isMobile={mobile}
          items={texts.faq.list}
          title={texts.faq.title}
          locale={locale}
          colorTheme="dark"
        />
      </FaqBlockWrapper>

      <div className="pt-2 pt-md-4">
        <SectionsWrapperStyled isOverflowHidden={true}>
          <CartSaleWideContainer productType={GOODS_TYPES.wgs} />
        </SectionsWrapperStyled>
      </div>
    </>
  )
}

WgsResults.propTypes = {
  locale: PropTypes.string.isRequired,
  pathCdn: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
}

export default WgsResults
